import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createMyCallHistoriesSlice = (set, get) => ({
    myCallHistories: {
        loading: false,
        data: [],
    },
    getMyCallHistories: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ myCallHistories: { ...state.myCallHistories, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/crm/my-call-histories/${param.FromDate}/${param.ToDate}`,
                headers: { token },
            });
            set(state => ({ myCallHistories: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ myCallHistories: { ...state.myCallHistories, loading: false } }));
        }
    }
});
